import React from "react";
import { permissionLabel } from "../utils/permissions";

export function PermissionBadge({ role, workspaceAccess }) {
  const label = permissionLabel(role, workspaceAccess);
  return (
    <span className="lw-permission" title={`Highest permission: ${label}`}>
      {label}
    </span>
  );
}
